import styled, { css } from 'styled-components';

export const Section = styled.section``;

export const SectionWrapper = styled.article`
	${({ theme }: any) => css`
		margin-top: -8rem;
		margin-bottom: 4rem;

		@media (min-width: ${theme.breakpoints.tabletPortrait}) {
			margin-top: -19rem;
			margin-bottom: 6.4rem;
		}

		@media (min-width: ${theme.breakpoints.desktop}) {
			margin-top: -24.5rem;
		}
	`};
`;
